module.exports = __webpack_public_path__ + "assets/img/bg-top.1e7d72e1.png";